module.exports = __webpack_public_path__ + "img/united ats Final LOGO.a9b9db4c.png";